<template>
<div class="content2">
  <div class="header">
<!--    <el-button @click="toExcelTable">在管项目立案率报表</el-button>-->
    <el-button @click="getExcel2">立案率统计报表</el-button>
    <el-button @click="getExcel">导出模板</el-button>
    <el-button @click="importExcel">导入数据</el-button>
<!--    <el-button @click="printJs">打印</el-button>-->
  </div>
  <div class="body" id="lian-table">
    <el-table :data="pageData.list" border height="70vh" v-loading="table_loading">
      <el-table-column label="类型" align="center" prop="cate_name" width="150" fixed></el-table-column>
      <el-table-column label="战区" align="center" prop="zq_name" width="160" fixed></el-table-column>
      <el-table-column label="片区" align="center" prop="pq_name" width="160" fixed></el-table-column>
      <el-table-column label="项目" align="center" prop="project_name" width="180" fixed></el-table-column>
      <el-table-column label="统计类型" align="center" prop="level_name" width="100">
<!--        <template slot="header" slot-scope="scope">-->
<!--          {{scope.row.level_name}}-->
<!--        </template>-->
      </el-table-column>
      <el-table-column label="1至2年欠费状况" align="center">
        <el-table-column label="户数" align="center" width="100" prop="one_years_ago_count"></el-table-column>
        <el-table-column label="金额" align="center" width="100" prop="one_years_ago_amount"></el-table-column>
      </el-table-column>
      <el-table-column label="两年以上欠费状况" align="center">
        <el-table-column label="户数" align="center" width="100" prop="two_years_ago_count"></el-table-column>
        <el-table-column label="金额" align="center" width="100" prop="two_years_ago_amount"></el-table-column>
      </el-table-column>
      <el-table-column label="年度诉讼计划" align="center">
        <el-table-column label="户数" align="center" width="100" prop="year_count_plan"></el-table-column>
        <el-table-column label="金额" align="center" width="100" prop="year_amount_plan"></el-table-column>
      </el-table-column>
      <el-table-column label="立案比例" align="center">
        <el-table-column label="户数" align="center" width="100" prop="ss_count_rate"></el-table-column>
        <el-table-column label="金额" align="center" width="100" prop="ss_amount_rate"></el-table-column>
      </el-table-column>
      <el-table-column label="当月完成情况" align="center">
        <el-table-column label="当月计划" align="center">
          <el-table-column label="户数" align="center" width="100" prop="month_count_plan"></el-table-column>
          <el-table-column label="金额" align="center" width="100" prop="month_amount_plan"></el-table-column>
        </el-table-column>
        <el-table-column label="提交" align="center">
          <el-table-column label="户数" align="center" width="100" prop="tj_count"></el-table-column>
          <el-table-column label="金额" align="center" width="100" prop="tj_amount"></el-table-column>
        </el-table-column>
        <el-table-column label="诉调" align="center">
          <el-table-column label="户数" align="center" width="100" prop="st_count"></el-table-column>
          <el-table-column label="金额" align="center" width="100" prop="st_amount"></el-table-column>
        </el-table-column>
        <el-table-column label="立案" align="center">
          <el-table-column label="户数" align="center" width="100" prop="la_count"></el-table-column>
          <el-table-column label="金额" align="center" width="100" prop="la_amount"></el-table-column>
        </el-table-column>
        <el-table-column label="回款" align="center">
          <el-table-column label="户数" align="center" width="100" prop="hk_count"></el-table-column>
          <el-table-column label="金额" align="center" width="100" prop="hk_amount"></el-table-column>
        </el-table-column>
        <el-table-column label="合计" align="center">
          <el-table-column label="户数" align="center" width="100" prop="month_count_actuality"></el-table-column>
          <el-table-column label="金额" align="center" width="100" prop="month_amount_actuality"></el-table-column>
        </el-table-column>
        <el-table-column label="立案率" align="center" width="100" prop="la_rate"></el-table-column>
      </el-table-column>
      <el-table-column label="下月诉讼计划" align="center">
        <el-table-column label="户数" align="center" width="100" prop="next_month_count"></el-table-column>
        <el-table-column label="金额" align="center" width="100" prop="next_month_amount"></el-table-column>
      </el-table-column>
      <el-table-column label="累计完成情况" align="center">
        <el-table-column :label="`1-${selectMonthValue}月累计计划`" align="center">
          <el-table-column label="户数" align="center" width="100" prop="t_month_count_plan"></el-table-column>
          <el-table-column label="金额" align="center" width="100" prop="t_month_amount_plan"></el-table-column>
        </el-table-column>
        <el-table-column label="提交" align="center">
          <el-table-column label="户数" align="center" width="100" prop="t_tj_count"></el-table-column>
          <el-table-column label="金额" align="center" width="100" prop="t_tj_amount"></el-table-column>
        </el-table-column>
        <el-table-column label="诉调" align="center">
          <el-table-column label="户数" align="center" width="100" prop="t_st_count"></el-table-column>
          <el-table-column label="金额" align="center" width="100" prop="t_st_amount"></el-table-column>
        </el-table-column>
        <el-table-column label="立案" align="center">
          <el-table-column label="户数" align="center" width="100" prop="t_la_count"></el-table-column>
          <el-table-column label="金额" align="center" width="100" prop="t_la_amount"></el-table-column>
        </el-table-column>
        <el-table-column label="回款" align="center">
          <el-table-column label="户数" align="center" width="100" prop="t_hk_count"></el-table-column>
          <el-table-column label="金额" align="center" width="100" prop="t_hk_amount"></el-table-column>
        </el-table-column>
        <el-table-column label="合计" align="center">
          <el-table-column label="户数" align="center" width="100" prop="t_month_count_actuality"></el-table-column>
          <el-table-column label="金额" align="center" width="100" prop="t_month_amount_actuality"></el-table-column>
        </el-table-column>
        <el-table-column label="立案率" align="center" width="100" prop="t_la_rate"></el-table-column>
      </el-table-column>
      <el-table-column label="累计提交户数" align="center">
        <el-table-column label="户数" align="center" width="100" prop="total_count"></el-table-column>
        <el-table-column label="金额" align="center" width="100" prop="total_amount"></el-table-column>
      </el-table-column>


    </el-table>
  </div>
  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                   :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                   @current-change="pageChange"></el-pagination>
  </div>

<SelectMonth ref="SelectMonth" />
</div>
</template>

<script>
import PrintOne from "../../../../assets/lib/PrintOne";
import ToExcel from "../common/ToExcel"
import moment from "moment";
import Http from "../common/Http";
import SelectMonth from "./legal/SelectMonth";
import ButlerHttp from "../common/ButlerHttp";
// import FileSaver from 'file-saver'
// import * as XLSX from 'xlsx'


export default {
  name: "LiAnTableStatistics2",
  components: {SelectMonth},
  inject:['where','reginWhere'],
  data(){
    return{
      table_loading:false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 500,
        page: 1,
      },
      selectMonthValue:moment().format("M"),
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    getList() {
      const that = this;
      let where = ERP.reJson(that.where);
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      if(that.reginWhere.age) where.age=that.reginWhere.age;
      that.table_loading=true;
      ButlerHttp.post("Litigation/collectionProceeding2", {
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.table_loading = false;
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getExcel() {
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      if(that.reginWhere.age) where.age=that.reginWhere.age;

      ButlerHttp.post("Litigation/exportExcelTable", {
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        if (res.code) {
          window.open(__HTTP__.defaults.baseURL + res.data);
        } else {
          that.$message.error(res.msg || "导出失败");
        }
      });
    },
    getExcel2() {
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;

      ButlerHttp.post("Litigation/exportExcelTable2", {
        ...where
      }, res => {
        if (res.code) {
          window.open(__HTTP__.defaults.baseURL + res.data);
        } else {
          that.$message.error(res.msg || "导出失败");
        }
      });
    },
    importExcel(){
      const that=this;
      Http.uploadFile(file=>{
        that.$refs.SelectMonth.show(null,month=>{
          const loading=that.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          ButlerHttp.post("Litigation/importExcelTable", {
            file: file,
            month: month
          }, res => {
            loading.close();
            if (res.code) {
              that.getList();
            } else {
              that.$message.error(res.msg);
            }
          });
        })
      })
    },
    printJs(){
      PrintOne("#lian-table").extend({
        onStart: function () {
          console.log("开始打印")
        },
        onEnd: function () {
          console.log("打印完成")
        }
      })
    },
    toExcelTable(){
      ToExcel.toExcelFile("lian-table2","立案统计")
    },

    // toExcelTable2(){
    //   /* generate workbook object from table */
    //   let wb = XLSX.utils.table_to_book(document.getElementById("lian-table2"));  //表格的id
    //   /* get binary string as output */
    //   let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
    //   try {
    //     FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '立案统计.xlsx')
    //   } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
    //   console.log(wbout)
    // },
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_region":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_name":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.area_id":function (n,o) {
      this.pageChange(1)
    },
    "where.text":function (n,o) {
      this.pageChange(1)
    },
    "where.start_time":function (n,o) {
      this.selectMonthValue=moment(n).format("M");
      this.pageChange(1)
    },
    "where.end_time":function (n,o) {
      this.pageChange(1)
    }
  },
  computed:{
    last_month(){
      return (moment(this.start_time.replace('-','/')+'/01').get('month')+1)
    },
    start_time(){
      return this.where.start_time
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./LiAnTableStatistics.scss";
.content2{
  .header{
    padding: 10px 0;
  }
  .body{
    width: 100%;
    //overflow-x: scroll;

    .table-left{
      position: sticky;
      left: 0;
      background-color: #FFFFFF;
      border: 1px solid #000000;
    }
  }

  >>>.el-table--border, .el-table--group{
    border: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
    border-bottom: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/LiAnTableStatistics2.vue